import * as yup from 'yup'

export class VehicleOdometerAfterModificationPhotoDto {
  documentGuid?: string = undefined
  displayFileName?: string = undefined
  photoFile?: File = undefined
}

export const vehicleOdometerAfterModificationPhotoValidationSchema = yup
  .object({
    documentGuid: yup.string().nullable(),
    photoFile: yup.mixed().nullable()
  })
  .test('photo-required', 'Photo is required.', values => Boolean(values?.photoFile || values?.documentGuid))
